import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Link, OAuthAuthenticationService, withRouter, logoutAction,
} from '@ipc/ipc-core';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import axios from 'axios';
import './authInfo.scss';
import { showExpiredNotification } from './notifications/redux/actions/NotificationActions';
import { getAuthState } from './redux/selectors/authInfoSelector';

const mapStateToProps = (state) => ({
  auth: getAuthState(state),
});

let interceptors = null;

const Authenticated = (props) => {
  const {
    internalLogout,
    notify,
    auth,
    history,
  } = props;
  interceptors = axios.interceptors.response.use(undefined, (err) => {
    if (err?.response?.status === 401 && auth.isAuthenticated()) {
      notify({
        type: 'ERROR',
        message: err?.response?.data?.message || 'Token Expired',
        history,
      });
      const error = {
        ...err,
        response: {
          data: {
            message: null,
          },
        },
      };

      return Promise.reject(error);
    }
    return Promise.reject(err);
  });

  return (
    <div className="auth-info">
      <div className="icon-container" id="user-sign-out">
        <FontAwesomeIcon icon="user-circle" className="icon" />
      </div>
      <div className="auth-info-context-menu">
        <div className="choice" onClick={internalLogout}>
          <FontAwesomeIcon icon="sign-out-alt" />
          <div className="label"><FormattedMessage id="app.signOut" /></div>
        </div>
      </div>
    </div>
  );
};

Authenticated.propTypes = {
  internalLogout: PropTypes.func,
  notify: PropTypes.func,
  auth: PropTypes.objectOf(PropTypes.shape),
  history: PropTypes.objectOf(PropTypes.shape),
};

const NoAuthenticated = (props) => {
  const { history } = props;
  return (
    <div className="auth-info">
      <div className="icon-container">
        <FontAwesomeIcon icon="user-circle" className="icon" />
      </div>
      <div className="auth-info-context-menu">
        <Link to={{ pathname: '/login', state: { from: history.location.pathname } }} className="choice">
          <FontAwesomeIcon icon="sign-in-alt" />
          <div className="label"><FormattedMessage id="app.signIn" /></div>
        </Link>
      </div>
    </div>
  );
};

NoAuthenticated.propTypes = {
  history: PropTypes.shape(),
};

export class AuthInfoComponent extends React.Component {
  render() {
    const {
      history, auth, logout, notify,
    } = this.props;
    const internalLogout = () => {
      if (interceptors) {
        axios.interceptors.response.eject(interceptors);
      }
      history.replace('/');
      OAuthAuthenticationService.logout();
      logout();
    };

    return (
      auth.isAuthenticated() ? <Authenticated auth={auth} internalLogout={internalLogout} notify={notify} history={history} />
        : <NoAuthenticated history={history} />
    );
  }
}

AuthInfoComponent.propTypes = {
  history: PropTypes.objectOf(PropTypes.shape),
  logout: PropTypes.func,
  auth: PropTypes.objectOf(PropTypes.shape),
  notify: PropTypes.func,
};

export default connect(mapStateToProps, { logout: logoutAction, notify: showExpiredNotification })(withRouter(AuthInfoComponent));
